
import { computed, defineComponent, ref, getCurrentInstance } from 'vue';
import Navbar from '@/components/Navbar.vue';
import AIFeedbackCursor from '@/components/AIFeedbackCursor.vue';
import { useToolGetters, useUserGetters } from '@/store';
import '@/styles/main.scss';

export default defineComponent({
  name: 'App',
  components: {
    Navbar,
    'ai-feedback-cursor': AIFeedbackCursor,
    MPopupBalloon: () => import('@/components/molecules/m-popup-balloon.vue')
  },
  setup(props, context: any) {
    const instance = getCurrentInstance();
    const { getUser, isDialogOpen } = useUserGetters(['getUser', 'getObjectId', 'isDialogOpen']);
    document.title = 'PilotCity  |  Build projects to win internships';
    // if (process.env.VUE_APP_NODE_ENV === 'production' && window.$chatwoot && getUser) {
    //   // FIXME: Enable HMAC validation
    //   const computedValue = getUser.value;
    //   if (computedValue) {
    //     window.$chatwoot?.setUser(computedValue._id, {
    //       email: computedValue.email,
    //       name: computedValue.firstName + computedValue.lastName,
    //       phone_number: computedValue.phoneNumber
    //     });
    //   }
    // }
    const { getLinearLoading: loading } = useToolGetters(['getLinearLoading']);
    const password = ref('');
    const show1 = ref(false);
    const isResetting = ref(false);

    const layout = computed(() => {
      return `${instance?.proxy?.$route?.meta?.layout || 'default'}-layout`;
    });
    return {
      layout,
      loading,
      isDialogOpen,
      password,
      show1,
      isResetting
    };
  }
  // provide: {

  // },
});
